import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LINKS = [
  ["/terms", "legal.terms"],
  ["/privacy", "legal.privacy"],
  ["/eula", "legal.eula"],
  ["/biometric-consent", "legal.biometric"],
  ["/delete-account", "legal.deletion"],
  ["/support", "support.title"],
];

// روابط كل المستندات القانونية — تظهر في أسفل كل صفحة قانونية وفي شاشة الدخول.
export const LegalLinks = ({ withLogin = false }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-4 text-xs font-semibold text-primary">
      {LINKS.map(([to, key]) => (
        <Link key={to} to={to} data-testid={`legal-link-${to.slice(1)}`}>
          {t(key)}
        </Link>
      ))}
      {withLogin ? (
        <Link to="/login" data-testid="legal-link-login">
          {t("reset.backToLogin")}
        </Link>
      ) : null}
    </div>
  );
};
